"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRateCalculatorOptionsDto = instanceOfRateCalculatorOptionsDto;
exports.RateCalculatorOptionsDtoFromJSON = RateCalculatorOptionsDtoFromJSON;
exports.RateCalculatorOptionsDtoFromJSONTyped = RateCalculatorOptionsDtoFromJSONTyped;
exports.RateCalculatorOptionsDtoToJSON = RateCalculatorOptionsDtoToJSON;
exports.RateCalculatorOptionsDtoToJSONTyped = RateCalculatorOptionsDtoToJSONTyped;
const RateCalculatorSectorOptionsDto_1 = require("./RateCalculatorSectorOptionsDto");
const RateCalculatorLocationOptionsDto_1 = require("./RateCalculatorLocationOptionsDto");
/**
 * Check if a given object implements the RateCalculatorOptionsDto interface.
 */
function instanceOfRateCalculatorOptionsDto(value) {
    if (!('adjustments' in value) || value['adjustments'] === undefined)
        return false;
    if (!('states' in value) || value['states'] === undefined)
        return false;
    if (!('locations' in value) || value['locations'] === undefined)
        return false;
    if (!('sectorCategories' in value) || value['sectorCategories'] === undefined)
        return false;
    if (!('sectors' in value) || value['sectors'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    return true;
}
function RateCalculatorOptionsDtoFromJSON(json) {
    return RateCalculatorOptionsDtoFromJSONTyped(json, false);
}
function RateCalculatorOptionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'adjustments': json['adjustments'],
        'states': json['states'],
        'locations': (json['locations'].map(RateCalculatorLocationOptionsDto_1.RateCalculatorLocationOptionsDtoFromJSON)),
        'sectorCategories': json['sectorCategories'],
        'sectors': (json['sectors'].map(RateCalculatorSectorOptionsDto_1.RateCalculatorSectorOptionsDtoFromJSON)),
        'specialties': json['specialties'],
    };
}
function RateCalculatorOptionsDtoToJSON(json) {
    return RateCalculatorOptionsDtoToJSONTyped(json, false);
}
function RateCalculatorOptionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'adjustments': value['adjustments'],
        'states': value['states'],
        'locations': (value['locations'].map(RateCalculatorLocationOptionsDto_1.RateCalculatorLocationOptionsDtoToJSON)),
        'sectorCategories': value['sectorCategories'],
        'sectors': (value['sectors'].map(RateCalculatorSectorOptionsDto_1.RateCalculatorSectorOptionsDtoToJSON)),
        'specialties': value['specialties'],
    };
}
//# sourceMappingURL=RateCalculatorOptionsDto.js.map